// /src/Saga/rootSaga.js
import { all } from "redux-saga/effects";
import { watchUpdateNotificationCount } from "./saga";

export default function* rootSaga() {
  yield all([
    watchUpdateNotificationCount(),
    // add other watchers here
  ]);
}
